import request from '@/router/axios';

export const dictionary = (code) => {
  return request({
    url: '/api/blade-system/dict-biz/dictionary',
    method: 'get',
    params: {
      code: code
    }
  })
}

export const tree = () => {
  return request({
    url: '/api/blade-system/dept/tree',
    method: 'get',
  })
}

